(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["quantity"] && !Shopify.designMode) return;
  try {
    class AuraQuantityOffers extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;
    this.addEventListener('change', (event) => {
      if (event.target.matches('[data-aura-offer]')) this.selectOffer(event.target);
    });
  }
  selectOffer(choice) {
    const form = this.closest('form');
    const input = this.querySelector('input[name="quantity"]');
    if (!form || !input) return;
    const quantity = Number(choice.value);
    if (![1, 2, 3].includes(quantity)) return;
    input.value = String(quantity);
    input.setAttribute('value', String(quantity));
    form.closest('product-form-component')?.setAttribute('data-quantity-default', String(quantity));
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    const status = this.querySelector('[data-aura-summary]');
    if (status) status.textContent = choice.dataset.summary;
    this.dispatchEvent(new CustomEvent('aura:offer-change', { bubbles: true, detail: { quantity, total: Number(choice.dataset.total), summary: choice.dataset.summary } }));
  }
}
if (!customElements.get('aura-quantity-offers')) customElements.define('aura-quantity-offers', AuraQuantityOffers);
  } catch(e) { console.error(e); }
})();

})();
